import { styled } from 'linaria/react';

export const LoyaltyRegistartionBannerWrapper = styled.div`
  width: 100%;
  height: 86px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  border-radius: var(--rounding-l);

  padding: 13px 0 13px var(--space-200);
  background-color: var(--control-accent);

  white-space: pre-wrap;

  @media (max-width: 1023px) and (min-width: 520px) {
    white-space: nowrap;
  }

  span {
    width: 130px;
  }
`;
